import { Chip, Group, ScrollArea } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { CATEGORY_DISPLAY_ORDER, getCategoryColor } from '../practicalInformationTypeColor.helper';

import styles from './PracticalInformationFilters.module.scss';
import { Props } from './PracticalInformationFilters.types';

const PracticalInformationFilters = ({ selectedCategories, onChange }: Props) => {
  const { t } = useTranslation();
  const isAllSelected = selectedCategories.length === 0;

  return (
    <div className={styles.container}>
      <ScrollArea className={styles.scrollArea} type="auto" offsetScrollbars="x">
        <Group className={styles.group} gap="xs">
          <Chip checked={isAllSelected} onChange={() => onChange([])} color="blue" variant="light">
            {t('practicalInformation.filters.all', 'Toutes')}
          </Chip>
          <Chip.Group multiple value={selectedCategories} onChange={onChange}>
            {CATEGORY_DISPLAY_ORDER.map(category => {
              const config = getCategoryColor(category);
              return (
                <Chip key={category} value={category} color={config.mantineColor} variant="light">
                  {t(`practicalInformation.types.${category}`)}
                </Chip>
              );
            })}
          </Chip.Group>
        </Group>
      </ScrollArea>
    </div>
  );
};

export default PracticalInformationFilters;
